module.exports = __webpack_public_path__ + "static/img/player_head_8.2bba6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_8.jpg
// module id = 0i3w
// module chunks = 1